<i18n>
{
  "fr": {},
  "en": {}
}
</i18n>

<template>
  <div>
    <l-map
      :style="style"
      :zoom="5"
      :center="center"
      :options="leafletMapOptions"
    >
      <l-tile-layer
        :url="jawgUrl"
        attribution="<a href='https://jawg.io?utm_medium=map&utm_source=attribution' title='Tiles Courtesy of Jawg Maps' target='_blank' class='jawg-attrib' >&copy; <b>Jawg</b>Maps</a> | <a href='https://www.openstreetmap.org/copyright' title='OpenStreetMap is open data licensed under ODbL' target='_blank' class='osm-attrib'>&copy; OSM contributors</a>"
      ></l-tile-layer>
      <template>
        <l-marker
          :lat-lng="{
            lng: entity.longitude,
            lat: entity.latitude
          }"
        >
          <l-popup>
            <h1>{{ entity.name }}</h1>
          </l-popup>
          />
        </l-marker>
      </template>
    </l-map>
  </div>
</template>

<script>
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import '@/plugins/leaflet.js'
import { LMap, LMarker, LTileLayer, LPopup } from 'vue2-leaflet'

export default {
  name: 'entityMap',
  data: function () {
    return {
      leafletMapOptions: {
        scrollWheelZoom: true
      },
      jawgUrl: `https://tile.jawg.io/${process.env.VUE_APP_JAWG_MAP_STYLE}/{z}/{x}/{y}.png?access-token=${process.env.VUE_APP_JAWG_MAP_ACCESS_TOKEN}`
    }
  },
  computed: {
    center: function () {
      return [this.entity.latitude, this.entity.longitude]
    },
    style: function () {
      let height = 300
      let style = `z-index: 0; height: ${height}px;`
      return style
    }
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  props: {
    entity: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
@import '~leaflet/dist/leaflet.css';
</style>
